module.exports = __webpack_public_path__ + "img/top_inside_reight.cbaa441e.svg";